// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-42921124] .van-tabbar-item__text {\n  font-size: 12px;\n  transform: scale(0.8);\n}\n.icon_box[data-v-42921124] {\n  height: 7.46667vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
